import { Warning } from "@phosphor-icons/react";
import { SITE_CONDITION_TYPES, DEFAULT_SITE_CONDITION_UPLIFT } from "../../lib/romEngine";

const normalize = (c) => (typeof c === "string" ? { text: c, type: "other" } : (c || { text: "", type: "other" }));

export function SiteConditions({ conditions, onAdd, onUpdate, onRemove }) {
    const rows = (conditions || []).map(normalize);
    return (
        <div className="mt-4 border border-[var(--rom-border)] rounded-[6px] overflow-hidden" data-testid="site-conditions-section">
            <div className="flex items-center justify-between px-4 py-2.5 bg-[var(--rom-orange-soft)]/30 border-b border-[var(--rom-border)]">
                <div className="flex items-center gap-2">
                    <Warning size={14} weight="bold" className="text-[var(--rom-navy)]" />
                    <span className="text-[12px] font-bold uppercase tracking-[0.08em] text-[var(--rom-text)]">Site conditions</span>
                    <span className="text-[11px] text-[var(--rom-text-3)]">optional</span>
                </div>
                <span className="text-[11px] text-[var(--rom-text-2)]">Each one adds its own labour uplift — unvalidated, editable</span>
            </div>
            <div className="p-3 space-y-2">
                {rows.length === 0 && (
                    <div className="text-center text-[var(--rom-text-3)] text-sm py-2" data-testid="site-conditions-empty">
                        No site conditions yet — add one, or mention them while dictating with the AI Estimator's mic.
                    </div>
                )}
                {rows.map((c, idx) => {
                    const pct = c.upliftPct != null && c.upliftPct !== "" ? Number(c.upliftPct) : (DEFAULT_SITE_CONDITION_UPLIFT[c.type] ?? 0);
                    return (
                        <div key={idx} className="flex items-start gap-2 flex-wrap sm:flex-nowrap" data-testid={`site-condition-row-${idx}`}>
                            <select
                                className="select py-1.5 px-2 text-sm w-full sm:w-[220px] shrink-0"
                                value={c.type || "other"}
                                onChange={(e) => onUpdate(idx, "type", e.target.value)}
                                data-testid={`site-condition-type-${idx}`}
                            >
                                {SITE_CONDITION_TYPES.map((t) => <option key={t.v} value={t.v}>{t.label}</option>)}
                            </select>
                            <input
                                className="input py-1.5 px-2 text-sm flex-1"
                                value={c.text || ""}
                                placeholder="e.g. Occupied building — work 8am-4pm only"
                                onChange={(e) => onUpdate(idx, "text", e.target.value)}
                                data-testid={`site-condition-text-${idx}`}
                            />
                            {c.type !== "other" && (
                                <div className="flex items-center gap-1 shrink-0" title="Labour uplift — unvalidated, editable on the Rate Schedule">
                                    <input
                                        type="number" step="0.1" min={0}
                                        className="input py-1.5 px-2 text-sm font-mono w-[64px] text-right"
                                        value={round1(pct * 100)}
                                        onChange={(e) => onUpdate(idx, "upliftPct", Number(e.target.value) / 100)}
                                        data-testid={`site-condition-uplift-${idx}`}
                                    />
                                    <span className="text-xs text-[var(--rom-text-2)]">% labour</span>
                                </div>
                            )}
                            <button onClick={() => onRemove(idx)} className="text-[var(--rom-danger)] hover:opacity-70 px-1 shrink-0" data-testid={`site-condition-del-${idx}`}>×</button>
                        </div>
                    );
                })}
                <button onClick={onAdd} className="w-full py-2 text-xs font-semibold text-[var(--rom-navy)] hover:bg-[var(--rom-orange-soft)]/30 rounded-[4px] transition-colors" data-testid="site-condition-add-row">
                    + Add site condition
                </button>
            </div>
        </div>
    );
}

function round1(n) { return Math.round((Number(n) || 0) * 10) / 10; }
